export interface JumboProps {
  readonly title: string
  readonly contents: string | JSX.Element
  readonly imageUrlSmall?: string
  readonly imageUrl: string
  readonly imageUrlLarge: string
  readonly imageAlt: string
  readonly buttonUrl?: string
  readonly buttonTitle?: any
  readonly size: 'small' | 'large'
  readonly kind?: "default" | "home" | "home-location" | "activity" | "collection"
}

export const emptyJumbo: JumboProps = {
  title: '',
  contents: '',
  imageUrlSmall: '',
  imageUrl: '',
  imageUrlLarge: '',
  imageAlt: '',
  size: 'large'
}

export type JumboComponent = (props: JumboProps) => JSX.Element
